<template>
    <div>
        <v-row>
            <v-col class="Full-Course-Library-Title">
                {{ $globalConfig.APP_NAME === 'senso' ? 'Sites' : 'Locations'}}
            </v-col>
            <v-btn style="float:right;" class="btn btn-primary add-course-button" color="primary" outlined
                @click="showCreatePanel">Create {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}}
            </v-btn>
        </v-row>
        <v-row class="mb-5">
            <v-col md="12">
                <v-card flat>
                    <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
                    <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table :headers="tableHeaders" v-show="!loading" :items="sites" item-key="id" class="mt-3">
                        <template v-slot:item.total_users="{ item }">
                                <span v-if="item.total_users" class="clickable-count" @click.stop="openDialog($event,item.users,'Users')">{{ item.total_users }}</span>
                                <span v-else>{{ item.total_users }}</span>
                        </template>
                        <template v-slot:item.id="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn :id="item.id" v-on="on" outlined small
                                        class="mr-1 action-button action-button-txt"
                                        @click.prevent="showEditPanel(item)">
                                        <span>Edit {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}}</span>
                                    </v-btn>
                                </template>
                                <span>Edit {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" x-small text color="$improve-grey-900"
                                        @click.prevent="deleteSite(item.id,item.total_users)" class="Frame-61">
                                        <v-icon small>fa fa-trash</v-icon>
                                    </v-btn>
                                </template>
                                <span>Delete {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}}</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <!-- Dialog -->
        <DialogComponent
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        @close="closeDialog"
        />
    </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import companyAPI from "@/api/company.js";
import CreateSite from "@/components/admin/sites/Create";
import EditSite from "@/components/admin/sites/Edit";
import DialogComponent from '@/components/Dialog';

export default {
    name: 'Site',
    components: {
        DialogComponent
    },
    data() {
        return {
            loading: false,
            tableHeaders: [
                { text: this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location',value: 'name',sortable: false,},
                { text: 'Users', value: 'total_users',sortable: false,},
                { text: '', value: 'id', align: 'end',sortable: false, },
            ],
            sites: [],
            confirmDelete: `Are you sure you wish to delete this ${this.$globalConfig.APP_NAME === "senso" ? "site" : "location"}?`,
            dialog: false,
            dialogTitle : '',
            dialogData: [],
            infoMsg: `Only ${this.$globalConfig.APP_NAME === "senso" ? "site" : "location"} with 0 users can be deleted. Please unassign users from the ${this.$globalConfig.APP_NAME === "senso" ? "site" : "location"} and try again.`,
            deleteSuccess: `${this.$globalConfig.APP_NAME === "senso" ? "Site" : "Location"} has been deleted successfully.`
        }
    },
    computed:{
        isTabletOrDesktop() {
            const width = this.$vuetify.breakpoint.width;
            return width >= 820;
        },
    },
    mounted() {
        this.getCompanySites();
        this.setEventBus();
    },
    methods: {
        getCompanySites() {
            this.loading = true;
            companyAPI.getCompanySites().then(response => {
                this.sites = response.data.data;
                this.loading = false;

            });
        },
        showCreatePanel() {
            this.$showPanel({
                component: CreateSite,
                openOn: 'right',
            });
        },
        showEditPanel(data) {
        this.$showPanel({
            component: EditSite,
            props: {
              site  : data,
            },
            openOn: 'right',
      });
     },
      deleteSite(id,totalUsers){
        this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.deleteSiteProcess(toast, id,totalUsers),
          },
        ],
      });
      },
      deleteSiteProcess(toast, id,totalUsers) {
      this.$snotify.remove(toast.id);
      if(totalUsers > 0){
        this.$snotify.confirm(this.infoMsg, {
        backdrop: 0.3,
        buttons: [
          { text: 'OKAY', className: 'toast-continue-button' },
        ],
         });
      }else{
      this.loading = true;
      companyAPI.deleteSite(id).then((resp) => {
        this.loading = false;
        this.$snotify.success(this.deleteSuccess);
        this.getCompanySites();
         });
        }
    },
    setEventBus() {
      EventBus.$on('SITES_UPDATED', () => {
            this.getCompanySites();
      });
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    }
    },
};
</script>